import { observer } from 'mobx-react-lite'
import { Avatar, Divider, Typography } from 'shared/ui'
import { PriceInfo } from 'entities/Billing'
import { type UpgradeMemberStore } from 'pages/settings/pages/members/ui/actions/upgradeMember/ui/UpgradeMemberModal/store/UpgradeMemberStore'

import styles from './styles.module.scss'

type IUpgradeMemberModalProps = {
  store: UpgradeMemberStore
}

export const UpgradeMemberModal = observer(({ store }: IUpgradeMemberModalProps) => {
  const { memberToUpgrade, priceInfoStore } = store

  if (!memberToUpgrade) return null

  return (
    <div>
      <Divider style={{ borderColor: 'var(--border-neutral-default)' }} />
      <div className={styles.memberWrap}>
        <Avatar size={40} info={memberToUpgrade.avatarInfo} />
        <div className={styles.memberInfo}>
          <Typography
            variant='body-lg-medium'
            color='var(--content-primary-primary)'
            ariaLabel='MemberName'
          >
            {memberToUpgrade.name}
          </Typography>
          <Typography
            variant='body-sm-regular'
            color='var(--content-primary-tertiary)'
            ariaLabel='MemberEmail'
          >
            {memberToUpgrade.email}
          </Typography>
        </div>
      </div>
      <PriceInfo priceInfoStore={priceInfoStore} labelPrefix='Seats' />
    </div>
  )
})
